<template>
  <div style="margin-bottom:56px;" class="hidden-sm-and-up">
    <div class="mobile_nav_wrap hidden-sm-and-up">
      <div class="navbar_left" @click="gobackHome">
        <img src="@/assets/img/home/yw_logo.png" alt="亿微电子..." />
		<p>亿微电子</p>
      </div>
      <div class="navbar_right">
        <div class="nav_btns" @click="moveMenu">
          <i class="el-icon-menu"></i>
        </div>
      </div>
    </div>
    <Affix>
      <div class="nav_menu" ref="menu">
        <router-link
          class="menu_item"
          to="/home"
          :class="currentActive === 1 ? 'active' : ''"
          >首页</router-link
        >
		<router-link
		  class="menu_item"
		  to="/profiles"
		  :class="currentActive === 2 ? 'active' : ''"
		  >公司简介</router-link
		>
        <div
          class="menu_item"
          @click="changeProductShow"
          :class="currentActive === 3 ? 'active' : ''"
        >
          <strong>产品中心</strong>
        </div>
        <div class="item_options" v-show="productShow">
          <a href="/product/1">产品类型</a>
          <a href="/product/2">产品应用</a>
        </div>
<!--        <router-link
          class="menu_item"
          to="/solution"
          :class="currentActive === 4 ? 'active' : ''"
          >解决方案</router-link
        >
		<router-link
		  class="menu_item"
		  to="/document"
		  :class="currentActive === 5 ? 'active' : ''"
		  >文档中心</router-link
		>
		<router-link
		  class="menu_item"
		  to="/news"
		  :class="currentActive === 6 ? 'active' : ''"
		  >新闻动态</router-link
		> -->
		<router-link
		  class="menu_item"
		  to="/contact"
		  :class="currentActive === 7 ? 'active' : ''"
		  >联系我们</router-link
		>
		<div
		  class="menu_item"
		  @click="gotoLogin"
		  :class="currentActive === 8 ? 'active' : ''"
		>
		  用户登录
		</div>
      </div>
    </Affix>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuShow: false,
      productShow: false,
      centerShow: false,
      fireShow: false,
    }
  },
  props: {
    currentActive: {
      default: 0,
      type: Number,
    },
  },
  methods: {
    moveMenu() {
      this.menuShow = !this.menuShow
      if (this.menuShow) {
        this.$refs.menu.style.top = '56PX'
      } else {
        this.$refs.menu.style.top = '-1000PX'
      }
    },
    changeProductShow() {
      this.productShow = !this.productShow
      this.centerShow = false
      this.fireShow = false
    },
    changeCenterShow() {
      this.centerShow = !this.centerShow
      this.fireShow = false
      this.productShow = false
    },
    changefireShow() {
      this.fireShow = !this.fireShow
      this.centerShow = false
      this.productShow = false
    },
    gotoExperience() {
      this.$router.push('/demo').catch((v) => {})
    },
    gobackHome(){
      this.$router.replace('/home').catch((v) => {})
    },
	gotoLogin() {
	  window.location.href = 'https://user.faywdz.com/';
	},
  },
}
</script>

<style lang="scss" scoped>
.mobile_nav_wrap {
  box-sizing: border-box;
  width: 100%;
  height: 56PX;
  background: #fff;
  z-index: 1000;
  display: flex;
  padding: 15PX 0 15PX 15PX;
  align-items: center;
  position: fixed;
  top: 0;
  .navbar_left {
    display: flex;
	justify-content: center;
    background: #fff;
    img {
      width: 28PX;
	  height: 28PX;
    }
	p {
	  font-size: 16PX;
	  margin-left: 10PX;
	  color: #1e91ca;
	}
  }
  .navbar_right {
    flex: 2;
    height: 56PX;
    display: flex;
    justify-content: flex-end;
    background: #fff; 
    .nav_tiyan {
      width: 88PX;
      height: 100%;
      background: #1a63c4;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14PX;
    }

    .nav_btns {
      width: 56PX;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      i{
        font-size: 30PX;
      }
    }
  }
}
.active{
  color: #F39C00 !important;
  font-weight: bold;
}
.nav_menu{
    position: absolute;
    width: 100%;
    height: 450PX;
    list-style: none;
    left: 0;
    right: 0;
    top: -1000PX;
    padding-bottom: 0;
    box-sizing: border-box;
    background: #EFF0F1;
    box-shadow: 0 10PX 20PX rgba(0,0,0,.1);
    z-index: 10;
    transition: all 0.8s;
    .menu_item{
      width: 100%;
      height: 40PX;
      font-size: 16PX;
      background: #EFF0F1;
      color: #1c212d;
      padding: 30PX;
      display: flex;
      align-items: center;
    }
    .item_options{
      width: 100%;
      padding: 5PX 10PX;
      height: 88PX;
      font-size: 14PX;
      background: #fff;
      a{
        display: inline-block;
        width: 100%;
        color: #666;
        height: 25%;
        padding: 58px 30PX;
      }
    }
  }
</style>